<style lang="scss"></style>

<template>
  <div id="modal-remove-atendimento" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="atendimento">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o atendimento:
                    <span class="text-info">
                      #{{ atendimento.protocolo }}
                      - {{ atendimento.contato }}
                      - {{ atendimento.tipo }}
                    </span> ?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../helpers';
import AtendimentoService from '../../services/AtendimentoService';

export default {
  name: 'modal-remove-atendimento',
  data() {
    return {
      enviando: false,
      atendimento: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-atendimento').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeAtendimentoId = null;
    });

    if (this.$parent.removeAtendimentoId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.atendimento = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeAtendimentoId === 0) return;

        this.atendimento = await AtendimentoService.findById(
          this.$parent.removeAtendimentoId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-atendimento').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await AtendimentoService.remove(this.atendimento.id);

        this.$toast.success('Atendimento removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-atendimento').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
